export default __webpack_public_path__ + "static/media/arrow.f481ab53.svg";